export default class Validator {
  static email(email) {
    if (typeof email !== "string") return false;
    const trimmed = email.trim();
    // Alinhado ao restante do app (ex.: login/signup): regex antiga rejeitava +alias, TLDs longos (.technology), etc.
    return /\S+@\S+\.\S+/.test(trimmed);
  }

  static name(name) {
    return /^[a-zA-Z ].{4,}$/.test(name);
  }

  static password(password) {
    return /^[A-Za-z0-9._@]{6,30}$/.test(password);
  }

  static CNPJ(cnpj) {
    cnpj = cnpj.replace(/[^\d]/g, '');

    if (cnpj.length !== 14) {
      return false;
    }

    let soma = 0;
    let peso = 5;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i)) * peso;
      peso = peso === 2 ? 9 : peso - 1;
    }
    let resto = soma % 11;
    const digito1 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cnpj.charAt(12)) !== digito1) {
      return false;
    }

    soma = 0;
    peso = 6;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i)) * peso;
      peso = peso === 2 ? 9 : peso - 1;
    }
    resto = soma % 11;
    const digito2 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cnpj.charAt(13)) !== digito2) {
      return false;
    }

    return true;
  }

  static CPF(cpf) {
    cpf = cpf.replace(/[^\d]/g, '');

    if (cpf.length !== 11) {
      return false;
    }

    let soma = 0;
    for (let i = 0; i < 9; i++) {
      soma += parseInt(cpf.charAt(i)) * (10 - i);
    }
    let resto = soma % 11;
    const digito1 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cpf.charAt(9)) !== digito1) {
      return false;
    }

    soma = 0;
    for (let i = 0; i < 10; i++) {
      soma += parseInt(cpf.charAt(i)) * (11 - i);
    }
    resto = soma % 11;
    const digito2 = resto < 2 ? 0 : 11 - resto;

    if (parseInt(cpf.charAt(10)) !== digito2) {
      return false;
    }

    return true;
  }
}
